import * as React from 'react'
import { useEffect, useState } from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useSelector } from 'react-redux'
import { Divider, IconButton, Select, Typography, FormControl, InputLabel, MenuItem, Grid, FormHelperText, Box, Paper } from '@mui/material'
import { printVariable } from '@util/helper'
import WebService from '@util/webService'
import useSnackbar from '@hooks/useSnackbar'
import useIndicator from '@hooks/useIndicator'
import axios from 'axios'
import { Fragment } from 'react'
import moment from 'moment'
import useDelegate from '@hooks/useDelegate'
import { styled } from '@mui/material/styles'
import useAlert from '@hooks/useAlert'
import ConfirmDialog from '@components/ConfirmDialog'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabContext from '@mui/lab/TabContext'
import TabPanel from '@mui/lab/TabPanel'
import Autocomplete from '@mui/material/Autocomplete'
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline'

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import 'dayjs/locale/ko'
import { takeRight } from 'lodash'
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined'
import AttachFileOutlinedIcon from '@mui/icons-material/AttachFileOutlined'
import CloseIcon from '@mui/icons-material/Close'
import { billiard } from '@util/string'
import { useTheme } from '@mui/material/styles'
import TeacherImg from './teacher-img'
import ImageViewer from '@pages/common/image-viewer'
const filterOptions = (options, state) => {
  let newOptions = []
  newOptions = options.filter((o) => o.name.includes(state.inputValue)).slice(0, 10)
  return newOptions
}

const dateFormat = 'YYYY-MM-DD HH:mm:ss'
const FormHelperTexts = styled(FormHelperText)`
  width: 100%;
  padding-left: 16px;
  font-weight: 700 !important;
  color: #d32f2f !important;
`

const topicMenuSchool = [
  // {name:'전체 관계자', value:'TP01'},
  // {name:'전체 학생 보호자', value:'TP04'},
  // {name:'전체 강사', value:'TP05'},
  { name: '강좌 관련자', value: 'TP06' },
  // {name:'특정수업일(출석부상) 관련자', value:'TP07'},
  { name: '개별학생 보호자', value: 'TP08' },
  // {name:'학년', value:'TP09'},
  // {name:'전체 수강생 보호자', value:'TP11'},
]

const topicMenuCompany = [
  { name: '전체 관계자', value: 'TP100' },
  { name: '전체 매니저', value: 'TP101' },
  { name: '전체 강사', value: 'TP102' },
]

const TeacherMessagePartPost = ({ dialogHandler, msgType, tid, sid, callback }) => {
  tid = tid ?? -1
  sid = sid ?? -1
  // redux
  const account = useSelector((state) => state.accountReducer)
  const schola = useSelector((state) => state.scholaReducer)
  const [topicMenu, set_topicMenu] = useState(topicMenuSchool)
  const [title, set_title] = useState('')
  const [content, set_content] = useState('')

  const [targetTopic, set_targetTopic] = useState('')
  const [targetLectures, set_targetLectures] = useState([])
  const [targetLectureId, set_targetLectureId] = useState(tid)
  const studentListRef = React.useRef([])
  const [allChecked, set_allChecked] = useState(true)
  const [data, set_data] = useState({
    topicMenu: topicMenu[0].value,
    lectureId: 0,
    title: '',
    content: '',
  })
  const theme = useTheme()
  const [grades, set_grades] = useState([
    { grade: 1, label: '1학년', isChecked: false },
    { grade: 2, label: '2학년', isChecked: false },
    { grade: 3, label: '3학년', isChecked: false },
    { grade: 4, label: '4학년', isChecked: false },
    { grade: 5, label: '5학년', isChecked: false },
    { grade: 6, label: '6학년', isChecked: false },
  ])

  const msgTitle = msgType === 'push' ? '푸시 메시지 전송' : '문자 메시지 전송'
  const [confirmMsg, set_confirmMsg] = useState('메시지를 발송하시겠습니까?')

  const [tabValue, set_tabValue] = useState('1')
  const [openSnackbar] = useSnackbar()
  const [openIndicator, closeIndicator, renderIndicator] = useIndicator()
  const { alert, renderAlert } = useAlert()
  const [students, set_students] = useState([])
  const [smst, set_smst] = useState({})
  const [smstList, set_smstList] = useState([])
  const [lectures, set_lectures] = useState([])
  const [files, set_files] = useState([])
  const imgHandler = useState(false)
  const [imgUrl, set_imgUrl] = useState()
  const handleClose = (event, reason) => {
    if (reason && reason === 'backdropClick') {
      return
    }
    else {
      dialogHandler[1](false)
      if (callback) {
        callback()
      }
    }
  }

  const fetchSmst = async () => {
    const url = `/smst/last/any/${schola.id}`
    const resp = await WebService.get(url)
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    return JSON.parse(repMessage.record)
  }

  const fetchStudents = async (lectureId) => {
    const url = `/student/lecture/${lectureId}`
    const resp = await WebService.get(url)
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const students = JSON.parse(repMessage.records)

    students.forEach((s) => {
      if (tid !== -1 && sid !== -1) {
        if (s.id === sid) {
          s.checked = true
        }
        else {
          s.checked = false
        }
      }
      else {
        s.checked = true
      }

      s.label = `${s.name}(${s.grade}학년, ${s.className}반, ${s.classNum}번)`
    })
    const checkedStudents = students.filter((r) => r.checked)
    if (checkedStudents.length === students.length) {
      set_allChecked(true)
    }
    else {
      set_allChecked(false)
    }

    set_students(students)
    // return JSON.parse(repMessage.records)
  }

  const searchStudent = async (word) => {
    // 4 byte check
    const regex = /[\uAC00-\uD7AF]+/g

    if (!regex.test(word)) {
      return []
    }

    const url = `/student/school/name/${schola.id}/${word}`
    const resp = await WebService.get(url)
    if (resp.repCode !== 'ack') {
      openSnackbar(resp.repMessage)
      return []
    }
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    for (const record of records) {
      // record.label = `${record.name}(${record.gdnPhone})`
      record.label = `${record.name}(${record.grade}학년, ${record.className}반, ${record.classNum}번)`
    }
    return records
  }

  const fetchSmsts = async () => {
    const url = `/smst/not/closed/${schola.id}`
    openIndicator()
    const resp = await WebService.get(url)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    const records = JSON.parse(repMessage.records)
    records.sort((a, b) => b.id - a.id)
    records.forEach((r) => {
      r.isChecked = true
    })
    return records
  }

  const fetchLectures = async (smstIdList) => {
    const url = `/lecture/smstids/${account.user.id}`
    openIndicator()
    const resp = await WebService.post(url, smstIdList)
    closeIndicator()
    if (resp.repCode !== 'ack') {
      alert(resp.repMessage)
      return
    }
    const repMessage = JSON.parse(resp.repMessage)
    return JSON.parse(repMessage.records)
  }

  const onLoad = async () => {
    console.log('onLoad...')
    /*
    const smst = await fetchSmst()
    if(smst) {
      set_smst(smst)
      const lectures = await fetchLectures(smst.id)
      if(lectures) {
        set_lectures(lectures)
      }
    }
    */
    const smstList = await fetchSmsts()
    if (smstList) {
      set_smstList(smstList)
      const idList = smstList.map((r) => r.id)
      const lectures = await fetchLectures(idList)
      if (lectures) {
        lectures.sort((a, b) => a.title.localeCompare(b.title))
        for (const lecture of lectures) {
          const smst = smstList.find((r) => r.id === lecture.smstId)
          lecture.gisu = smst?.gisu
          lecture.smstPhase = smst?.phase
        }
        lectures.sort((a, b) => a.smstPhase - b.smstPhase)
        set_lectures(lectures)
      }
    }
  }

  const validate = () => {
    if (targetLectureId === -1) {
      alert('강좌가 선택되지 않았습니다.')
      return
    }

    const targetStudents = students.filter(r => r.checked)
    if (targetStudents.length == 0) {
      alert('메시지를 발송할 대상 학생이 선택되지 않았습니다.')
      return
    }

    if (!title) {
      alert('제목이 비어 있습니다.')
      return
    }
    if (!content) {
      alert('내용이 비어 있습니다.')
      return
    }
    return true
  }

  const canSubmit = async () => {
    const validated = validate()
    if (validated) {
      return true
    }

    return false
  }

  const onChangeFile = async (e) => {
    const selected = Array.from(e.target.files)
    // 같은 파일을 다시 선택해도 onChange가 발생하도록 input 값 초기화
    e.target.value = ''

    if (selected.length === 0) {
      return
    }

    // 이미 첨부된 파일과 이름/크기/수정시각이 같으면 중복으로 간주
    const isSameFile = (a, b) =>
      a.name === b.name && a.size === b.size && a.lastModified === b.lastModified
    const newOnes = selected.filter(s => !files.some(f => isSameFile(f, s)))

    if (newOnes.length === 0) {
      alert('이미 첨부된 파일입니다.')
      return
    }

    if (files.length + newOnes.length > 5) {
      alert(`파일은 최대 5개 까지만 첨부할 수 있습니다. (현재 ${files.length}개 첨부됨)`)
      return
    }

    const maxSize = 2 * 1024 * 1024  // 2MB
    const oversized = newOnes.filter(r => r.size > maxSize)
    if (oversized.length > 0) {
      alert(`파일 "${oversized[0].name}" 을(를) 포함한 ${oversized.length}개 파일이 2MB를 초과합니다.`)
      return
    }

    const filePromises = newOnes.map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
          file.imgUrl = reader.result
          resolve(file)
        }
        reader.onerror = reject
        reader.readAsDataURL(file)
      })
    })

    const filesWithUrl = await Promise.all(filePromises)
    // 기존 목록 뒤에 추가 (함수형 업데이트로 최신 state 기준 병합)
    set_files(prev => [...prev, ...filesWithUrl])
  }

  const onSubmit = async () => {
    const targetStudents = students.filter(r => r.checked)

    const topicCode = 'TP06'

    const pushUrl = encodeURI(`/topic/img/${schola.id}/${topicCode}`)
    const smsUrl = encodeURI(`/sms/${schola.id}/${topicCode}`)
    const url = msgType === 'push' ? pushUrl : smsUrl

    const params = {
      lectureId: targetLectureId,
      targetDate: '',
      etcId: '0',
    }

    const studentIds = targetStudents.map((r) => r.id)
    const targetGrades = grades.filter((r) => r.isChecked).map((r) => r.grade)
    const targetSmstIds = smstList.filter((r) => r.isChecked).map((r) => r.id)
    const data = {
      title: title,
      content: content,
      studentIds: studentIds,
      grades: targetGrades,
      smstIds: targetSmstIds,

    }
    const formData = new FormData()
    files.forEach((file, index) => {
      if (file instanceof File) {
        // formData.append(`files`, file)
        const f = new File([file], file.name, { type: file.type })
        formData.append('files', f)
      }
    })
    const jsonData = JSON.stringify(data)
    formData.append('body', new Blob([jsonData], { type: 'application/json' }))

    openIndicator()
    // const resp = await WebService.post(url, data, params)
    const resp = await axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      params: params,
    })
    closeIndicator()
    if (resp.data.repCode !== 'ack') {
      alert(resp.data.repMessage)
      return
    }
    alert('전송하였습니다.')

    callback()
  }

  const handleTabChange = (event, newValue) => {
    set_tabValue(newValue)
  }

  useEffect(() => {
    if (dialogHandler[0]) {
      onLoad()
    }
  }, [dialogHandler[0]])

  useEffect(() => {
    if (tabValue === '1') {
      set_topicMenu(topicMenuSchool)
    }

    if (tabValue === '2') {
      set_topicMenu(topicMenuCompany)
    }

    set_targetTopic('')
  }, [tabValue])

  useEffect(() => {
    set_targetTopic('TP06')
  }, [lectures])

  useEffect(() => {
    if (targetLectureId !== -1) {
      fetchStudents(targetLectureId)

      const lecture = lectures.find(r => r.id === targetLectureId)
      if (lecture) {
        const title = `${lecture.title} 알림(from 강사)`
        set_title(title)
      }
    }

  }, [targetLectureId])


  const Body = () => {

    const [studentList, set_studentList] = useState(studentListRef.current)

    return (
      <>
        {targetTopic !== '' ? (
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel id="lecture">강좌</InputLabel>
                <Select
                  labelId="topicMenu"
                  required
                  label="강좌"
                  value={targetLectureId}
                  onChange={async (e) => {
                    set_targetLectureId(e.target.value)
                  }}
                >
                  {lectures.map((l, index) => {
                    return (
                      <MenuItem key={index} value={l.id}>
                        {l.gisu} 기 / {l.title}
                      </MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              {targetLectureId !== -1 && students.length > 0 ? (
                <>
                  <input
                    type="checkbox"
                    id="allChecked"
                    checked={allChecked}
                    onChange={(e) => {
                      set_allChecked(e.target.checked)
                      const new_students = [...students]
                      new_students.forEach((s) => {
                        s.checked = e.target.checked
                      })
                      set_students(new_students)
                    }}
                  />{' '}
                  <label htmlFor="allChecked"> 전체 선택</label>
                </>
              ) : null}
            </Grid>

            <Grid item xs={12}>
              <div style={{ height: '40em', backgroundColor: '#fafafa', overflow: 'auto' }}>
                {students.map((s, idx) => (
                  <div key={idx} style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <div style={{ marginRight: 5 }}>
                      <input
                        type="checkbox"
                        id={s.id}
                        checked={s.checked}
                        onChange={(e) => {
                          const new_students = [...students]
                          new_students[idx].checked = e.target.checked
                          const checkedStudents = new_students.filter((r) => r.checked)
                          set_students(new_students)

                          if (checkedStudents.length === students.length) {
                            set_allChecked(true)
                          }
                          else {
                            set_allChecked(false)
                          }
                        }}
                      />
                      <label htmlFor={s.id}>{s.label}</label>
                    </div>
                    {/* <div style={{ marginRight: 5 }}>{s.label}</div> */}
                  </div>
                ))}
              </div>
            </Grid>
          </Grid>
        ) : null}
      </>
    )
  }

  return (
    <Fragment>
      {imgHandler[0] ? <ImageViewer dialogHandler={imgHandler} imgUrl={imgUrl} /> : null}
      <Dialog open={dialogHandler[0]} onClose={handleClose} maxWidth="lg" fullWidth>
        <DialogTitle>
          <Typography variant="h5" align="center">
            {msgTitle}
          </Typography>
          <Divider />
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} style={{ alignItems: 'center', justifyContent: 'center' }}>
              <Typography variant="body2" style={{ textAlign: 'center' }} color={theme.palette.secondary.main}>
                <CheckOutlinedIcon sx={{ fontSize: 15 }} /> 푸시 메시지의 경우 발신인도 수신인에 기본적으로 포함되어 발송됩니다.
              </Typography>
            </Grid>

            <Grid item xs={6}>
              {/* Left */}
              <Grid container spacing={2}>
                {msgType === 'push' ? (
                  <>
                    <Grid item xs={12}>
                      <Body />
                    </Grid>
                  </>
                ) : null}
              </Grid>
            </Grid>
            <Grid item xs={6}>
              {/* Right */}
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField label={'제목'} fullWidth name={'title'} value={title} onChange={(e) => set_title(e.target.value)} />
                </Grid>
                <Grid item xs={12}>
                  <TextField label={'내용'} fullWidth multiline rows={15} name={'content'} value={content} onChange={(e) => set_content(e.target.value)} />
                </Grid>
                <Grid item xs={12}>
                  <Typography variant='body2' color={theme.palette.secondary.main}>
                    {billiard} 파일은 JPG, PNG 파일만 선택가능하며, 2MB 이하 최대 5개 파일 까지 전송할 수 있습니다.
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Button component="label" variant="outlined" startIcon={<AttachFileOutlinedIcon />}>
                    첨부
                    <input
                      styles={{ display: 'none' }}
                      type="file"
                      accept=".jpg, .png"
                      hidden
                      multiple
                      onChange={(e) => {
                        onChangeFile(e)
                      }}
                    />
                  </Button>

                </Grid>
                <Grid item xs={12}>
                  {files.map((file, index) => (
                    <Grid container style={{ display: 'flex', alignItems: 'center' }}>
                      <Grid item xs={6} style={{ display: 'flex', alignItems: 'flex-start' }}>
                        <img src={file.imgUrl} width="100"
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            set_imgUrl(file.imgUrl)
                            imgHandler[1](true)
                          }}
                        />
                        <CloseIcon
                          style={{ fontSize: '1em', cursor: 'pointer' }}
                          onClick={() => {
                            const newFiles = [...files]
                            newFiles.splice(index, 1)
                            set_files(newFiles)
                          }}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <Typography key={index}>{file.name}</Typography>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Button onClick={handleClose}>닫기</Button>
          <ConfirmDialog
            btn={
              <Button variant="contained" color={'primary'}>
                전송
              </Button>
            }
            title={'알림'}
            content={confirmMsg}
            bc={'primary'}
            preHandle={async () => {
              return canSubmit()
            }}
            perform={() => {
              onSubmit()
            }}
          />
        </DialogActions>
      </Dialog>
      {renderIndicator()}
      {renderAlert()}
    </Fragment>
  )
}

export default TeacherMessagePartPost
